


import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import 'ldrs/ring';
import { auth, db } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import LeftSidebar from "../navigation/LeftSidebar";
import FloatingAIChat from "../common/FloatingAIChat";

const AdminRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [businessId, setBusinessId] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {

        try {
          const userDocRef = doc(db, "users", user.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            setIsAdmin(userData.isAdmin || false);
            setBusinessId(userData.businessId || null);
          } else {
            console.error("🚨 User document not found in Firestore.");
          }
        } catch (error) {
          console.error("❌ Error fetching user document:", error);
        }
      } else {
        // console.log("🔹 No user logged in.");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        {/* <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div> */}
      </div>
    );
  }

  if (!isAdmin) {
    console.error("⛔ Not an Admin. Redirecting...");
    return <Navigate to="/unauthorized" />;
  }

  if (!businessId) {
    console.error("⛔ Business ID is missing. Redirecting...");
    return <Navigate to="/error" />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <LeftSidebar onCollapsedChange={setSidebarCollapsed} />
      {/* Main content area - pushed right by sidebar on desktop */}
      <main className={`${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'} pt-16 min-h-screen transition-all duration-300`}>
        <Outlet context={{ businessId }} />
      </main>
      {/* Floating AI Chat - available on all admin screens */}
      <FloatingAIChat businessId={businessId} />
    </div>
  );
};

export default AdminRoute;

